var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.token)?_c('navbar'):_vm._e(),_c('v-main',{attrs:{"light":""}},[_c('router-view',{class:{
        'pr-12 pl-9': _vm.rps === 'lg' && _vm.token,
        'px-5': _vm.rps !== 'lg',
        'my-5': _vm.token
      }})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }